import PageDataContextService from "@core-ui/ContextServices/PageDataContext";

export const useIsGesCloudMode = (): boolean => {
	const { conf, isLogged } = PageDataContextService.value;
	const { url, enabled } = conf.enterpriseCloud;
	return Boolean(url && enabled && isLogged);
};
